import { Model, modelRegistry } from './Model';
import { WriteOffItem } from '.';
import Printable from '../print/Printable';
import { documentHeader, documentSignatures, documentSpacer, documentTable, factLine } from '../print/DocumentLayout';
import Money from '../utilities/Money';
import { I18n } from '../wrappers/I18n';
import Store from '../wrappers/Store';
import moment from 'moment-timezone';
export class WriteOff extends Model {
    static entity = 'write_offs';
    id = null;
    user_id = null;
    number = null;
    warehouse_id = null;
    date = null;
    description = null;
    recorded_at = null;
    created_at = null;
    updated_at = null;
    items = [];
    warehouse = null;
    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            number: this.attr(null),
            warehouse_id: this.attr(null),
            date: this.attr(null),
            description: this.attr(null),
            recorded_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            items: this.attr([], (value) => (value || []).map(item => new WriteOffItem(item))),
            warehouse: this.attr(null, (value) => value ? { id: Number(value.id), name: String(value.name) } : null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    getSellingValue() {
        return this.items.reduce((acc, cur) => acc.add(cur.getSellingValue()), Money.parse(0));
    }
    getTax() {
        return this.items.reduce((acc, cur) => acc.add(cur.getTax()), Money.parse(0));
    }
    getSellingValueAfterTax() {
        return this.items.reduce((acc, cur) => acc.add(cur.getSellingValueAfterTax()), Money.parse(0));
    }
    getPrintable() {
        const pr = new Printable();
        const venue = Store.get('tenant')?.venue;
        if (!venue)
            return pr;
        documentHeader(pr, {
            title: I18n.t('write_offs.heading'),
            facts: factLine([I18n.t('write_offs.number'), this.number], [I18n.t('write_offs.date'), moment(this.date).format('DD.MM.YYYY.')], [I18n.t('write_offs.description'), this.description]),
            venueName: venue.name,
            venueLine: `${I18n.t('general.tax_id_number')}: ${venue.tax_id_number}`,
        });
        documentSpacer(pr);
        const figure = (key) => ({ label: I18n.t(`write_offs.${key}`), kind: 'figure' });
        const columns = [
            { label: I18n.t('general.number'), kind: 'index' },
            { label: I18n.t('general.code'), kind: 'code' },
            { label: I18n.t('general.inventory_item'), kind: 'name' },
            figure('quantity'),
            figure('selling_price'),
            figure('selling_price_after_tax'),
            figure('selling_value'),
            { label: `${I18n.t('write_offs.tax_rate')} %`, kind: 'figure' },
            figure('tax'),
            figure('selling_value_after_tax'),
        ];
        const rows = this.items.map((item, index) => [
            String(index + 1),
            item.getProduct()?.code || '',
            item.getProduct()?.name || '',
            `${item.getQuantity()} ${item.getUnitOfMeasure()}`,
            item.getSellingPrice().toFormat('0.00'),
            item.getSellingPriceAfterTax().toFormat('0.00'),
            item.getSellingValue().toFormat('0.00'),
            item.getTaxRate() + '',
            item.getTax().toFormat('0.00'),
            item.getSellingValueAfterTax().toFormat('0.00'),
        ]);
        documentTable(pr, columns, rows, {
            density: 'regular',
            totals: {
                label: `${I18n.t('general.total').toUpperCase()}:`,
                span: 6,
                values: [this.getSellingValue().toFormat('0.00'), '', this.getTax().toFormat('0.00'), this.getSellingValueAfterTax().toFormat('0.00')],
            },
        });
        documentSignatures(pr, [I18n.t('general.created_by'), I18n.t('general.received_by'), I18n.t('general.responsible_person')]);
        return pr;
    }
}
export default WriteOff;
modelRegistry.register('WriteOff', WriteOff);
//# sourceMappingURL=WriteOff.js.map